// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== GLOBAL RESET ==================== */

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  body,
  html {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      "Helvetica Neue", Arial, sans-serif;
    width: 100%;
    min-height: 100vh;
    background-color: #100e0e;
  }
  
  /* ==================== PAGE WRAPPER ==================== */
  .uaf-page-wrapper {
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100%;
    background: #030303;
    overflow: hidden;
    box-sizing: border-box;
  }
  
  /* =========================================================
     MAIN PAGE
     Fixed viewport.
  
     IMPORTANT:
     The page itself DOES NOT scroll.
     ========================================================= */
  
     .uaf-page {
      width: 100%;
      height: 100vh;
      min-height: 0;
    
      display: flex;
      flex-direction: column;
      overflow: hidden;
      background: rgb(4, 4, 4);
    }
    
    
    /* =========================================================
       PAGE GRID
       This is the ONLY scrolling region.
       ========================================================= */
    
    .uaf-page-grid {
      display: grid;
    
      grid-template-columns:
        280px
        minmax(0, 1fr)
        280px;
    
      grid-template-areas:
        "left middle right";
    
      width: 100%;
    
      /*
       * Critical:
       * grid must be allowed to shrink inside the viewport.
       */
      flex: 1 1 auto;
      min-height: 0;
    
      /*
       * Don't use height: 100vh here.
       * The navbar + footer already consume part of the viewport.
       */
      height: auto;
    
      background: rgb(4, 4, 4);
    
      /*
       * THIS is the only vertical scroll.
       */
      overflow-y: auto;
      overflow-x: hidden;
    
      scroll-behavior: smooth;
    
      /*
       * Hide scrollbar but preserve scrolling.
       */
      scrollbar-width: none;
      -ms-overflow-style: none;
    
      box-sizing: border-box;
    }
    
    
    /* Chrome / Safari / Edge */
    
    .uaf-page-grid::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
    
    .uaf-page-grid::-webkit-scrollbar-track {
      background: transparent;
    }
    
    .uaf-page-grid::-webkit-scrollbar-thumb {
      background: transparent;
    }

/* =========================================================
   MIDDLE COLUMN
   No independent scrolling
   ========================================================= */

.uaf-middle-container {
  grid-area: middle;

  width: 95%;
  height: auto;
  min-height: 0;

  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  padding: 0 1rem 4rem 1rem;

  box-sizing: border-box;

  /*
   * IMPORTANT:
   * Do NOT create another scroll container here.
   */
  overflow: visible;

  scrollbar-width: none;
}

.uaf-middle-container::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}


/* =========================================================
   FEED
   Expands based on number of posts
   ========================================================= */

.uac-main-feed-container {
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;

  margin: 40px auto;

  border-radius: 20px;

  /*
   * Let the feed grow naturally.
   */
  height: auto;
  min-height: 0;
  max-height: none;

  /*
   * IMPORTANT:
   * No nested scrolling.
   */
  overflow: visible;

  box-sizing: border-box;
}

  /* ==================== LEFT SIDEBAR ==================== */
  
  .uaf-left-sidebar {
    grid-area: left;
    position: sticky;
    top: 0;
    align-self: stretch;
    height: 100vh;
    max-height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    scrollbar-width: none;
    -ms-overflow-style: none;
    background: transparent;
    padding: 0;
    box-sizing: border-box;
  }
  
  .uaf-left-sidebar::-webkit-scrollbar {
    display: none;
  }
  
  /* ==================== MIDDLE CONTAINER ==================== */
  
  
  
  /* ==================== RIGHT SIDEBAR ==================== */
  
  .uaf-right-sidebar {
    grid-area: right;
    position: sticky;
    top: 0;
    align-self: stretch;
    height: 100vh;
    max-height: 100vh;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    scrollbar-width: none;
    -ms-overflow-style: none;
    background: transparent;
    padding: 0;
    box-sizing: border-box;
  }
  
  .uaf-right-sidebar::-webkit-scrollbar {
    display: none;
  }
  
  .uaf-sidebar-inner {
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 1.5rem;
    justify-content: flex-start;
    align-items: center;
    padding: 1rem 0;
    box-sizing: border-box;
  }
  
  /* ==================== RIGHT SIDEBAR CONTENT ==================== */
  
/**
 * .uaf-ad-slot
 * 300x300 square placeholder. Both width/height AND aspect-ratio are set as a
 * belt-and-suspenders approach for older browser compatibility.
 * The dashed border and low-opacity background signal "ad goes here" to
 * developers without being visually distracting in the live UI.
 */
 .uaf-ad-slot {
  width: 250px;
  height: 250px;
  aspect-ratio: 1 / 1;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.03);
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.4);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-weight: 500;
  transition: background 200ms ease;
  flex-shrink: 0;
  box-sizing: border-box;
}

.uaf-ad-slot:hover {
  background: rgba(255, 255, 255, 0.06);
}

/**
 * .uaf-ad-placeholder-label
 * Non-interactive label inside each placeholder slot.
 */
.uaf-ad-placeholder-label {
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
}

/* --------------------------------------------------------------------------
   RIGHT SIDEBAR CONTENT CLASSES
   Preserved verbatim from the original stylesheet — these power the real
   profile-header / avatar / stars content that may be placed in the right
   sidebar by other components.
   -------------------------------------------------------------------------- */

.uaf-right-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.uaf-right-top-section {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  gap: 1rem;
}

.uaf-right-profile-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 0;
}

.uaf-right-profile-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  width: 100%;
}

.uaf-right-profile-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid rgba(255, 255, 255, 0.15);
  flex-shrink: 0;
}

.uaf-right-profile-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
}

.uaf-right-profile-name {
  font-size: 0.9rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
}

.uaf-right-profile-stars {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
}


  .uaf-right-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    gap: 1rem;
  }
  
  .uaf-right-top-section {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  .uaf-right-profile-header {
    padding: 0.75rem;
    border-radius: 10px;
  }
  
  .uaf-right-profile-info {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }
  
  .uaf-right-profile-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
  }
  
  .uaf-right-profile-details {
    flex: 1 1;
  }
  
  .uaf-right-profile-name {
    color: white;
    font-weight: 600;
    font-size: 1rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  
  .uaf-right-profile-stars {
    color: #ffd700;
    font-size: 0.875rem;
  }
  
  .uaf-right-suggestions {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    padding: 0.75rem;
    border-radius: 10px;
  }
  
  .uaf-right-suggestions-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    padding: 0.5rem 0;
  }
  
  .uaf-right-suggestions-title {
    color: white;
    font-size: 1.125rem;
    font-weight: 500;
  }
  
  .uaf-right-toggle-icon {
    font-size: 1.5rem;
    color: white;
    -webkit-user-select: none;
            user-select: none;
  }
  
  .uaf-right-suggestions-content {
    overflow: hidden;
    transition: max-height 0.3s ease;
    scrollbar-width: none;
    -ms-overflow-style: none;
    min-height: 300px;
  }
  
  .uaf-right-suggestions-content::-webkit-scrollbar {
    display: none;
  }
  
  .uaf-right-suggestions-content.collapsed {
    max-height: 0;
  }
  
  .uaf-right-suggestions-content.expanded {
    max-height: 300px;
    overflow-y: auto;
    margin-top: 0.5rem;
  }
  
  .uaf-right-suggestions-list {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .uaf-right-suggestion-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem;
    border-radius: 8px;
    transition: background 0.2s ease;
  }
  
  .uaf-right-suggestion-item:hover {
    background: rgba(255, 255, 255, 0.05);
  }
  
  .uaf-right-suggestion-info {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex: 1 1;
  }
  
  .uaf-right-suggestion-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
  }
  
  .uaf-right-suggestion-details {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }
  
  .uaf-right-suggestion-name {
    color: white;
    font-weight: 600;
    font-size: 0.9rem;
  }
  
  .uaf-right-suggestion-location {
    color: rgba(200, 200, 200, 0.7);
    font-size: 0.8rem;
  }
  
  .uaf-right-connect-btn {
    padding: 0.4rem 0.75rem;
    border-radius: 6px;
    cursor: pointer;
    border: none;
    font-size: 0.8rem;
    background: rgba(255, 255, 255, 0.3);
    color: white;
    backdrop-filter: blur(6px);
    transition: all 0.2s ease;
    font-weight: 500;
  }
  
  .uaf-right-connect-btn:hover {
    background: rgba(255, 255, 255, 0.4);
    transform: translateY(-1px);
  }
  
  .uaf-right-connect-btn.connected {
    background: rgba(234, 67, 53, 0.3);
  }
  
  .uaf-right-bottom-section {
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .uaf-right-ad-image {
    width: 100%;
    max-width: 200px;
    height: 200px;
    border-radius: 12px;
    object-fit: cover;
  }
  
  /* ==================== CENTER ONLY LAYOUT ==================== */
  
  .uaf-center-only-grid {
    display: flex;
    justify-content: center;
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    padding: 1.5rem;
    flex: 1 1;
  }
  
  .uaf-center-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding-bottom: 4rem;
  }
  
  /* ==================== FEED WRAPPER ==================== */
  
  .uac-feed-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  
  .uac-main-feed {
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding-bottom: 3rem; /* ✅ Extra space for footer */
  }
  
  /* ==================== FOOTER (CENTERED) ==================== */
  
  .uaf-footer {
    width: 100%;
    background: linear-gradient(180deg, rgba(18, 18, 18, 0.95) 0%, rgba(0, 0, 0, 1) 100%);
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    height: 30px;
  }
  
  .uaf-footer-content {
    max-width: 1800px;
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .uaf-footer-text {
    margin: 0;
    color: rgba(255, 255, 255, 0.65);
    font-size: 12px;
    font-weight: 400;
    line-height: 1.4;
  }
  
  .uaf-footer-copyright {
    color: rgba(255, 255, 255, 0.7);
    font-size: 0.875rem;
    font-weight: 400;
    margin: 0;
    line-height: 1.4;
  }
  
  /* ==================== PROFILE & CONTAINER VARIANTS ==================== */
  
  .uaf-central-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 1.25rem;
    padding: 1.25rem;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    min-height: 400px;
  }
  
  .uaf-profile-container {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    width: 100%;
    max-width: 100%;
    border-radius: 12px;
    overflow: hidden;
  }
  
  .uaf-profile-card {
    width: 200px;
    height: 200px;
    border-radius: 12px;
    overflow: hidden;
    text-align: center;
    transition: transform 0.3s ease;
    background: rgb(34, 31, 31);
  }
  
  .uaf-profile-card:hover {
    transform: scale(1.05);
  }
  
  .uaf-top-container {
    width: 100%;
    min-height: 100px;
    border-radius: 12px;
    display: flex;
    flex-direction: row;
    gap: 1rem;
    padding: 1rem;
    overflow: hidden;
  }
  
  .uaf-bottom-container {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    width: 100%;
    max-height: 600px;
    border-radius: 12px;
    padding: 1rem;
    overflow: hidden;
  }
  
  .uaf-header-title {
    flex: 0 0 40%;
    max-width: 40%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-radius: 12px;
    overflow: hidden;
  }
  
  .uaf-search-bar {
    flex: 1 1;
    max-width: 60%;
    border-radius: 12px;
    overflow: hidden;
  }
  
  .uaf-option-navigation-container {
    position: relative;
    width: 100px;
    height: auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  
  .uaf-menu-option-dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    width: 180px;
    max-height: 300px;
    background: rgb(34, 31, 31);
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);
    z-index: 1000;
    margin-top: 0.5rem;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  
  .uaf-menu-option-dropdown::-webkit-scrollbar {
    display: none;
  }
  
  .uaf-profile {
    width: 100%;
    height: auto;
    padding: 1rem;
  }
  
  /* ==================== RESPONSIVE: TABLET (768px - 1024px) ==================== */
  
  @media (max-width: 1024px) {
    .uaf-page-grid {
      grid-template-columns: 22% 1fr 25%;
      gap: 1rem;
      padding: 1rem;
    }
  
    .uaf-middle-container {
      padding: 0 0.5rem 4rem 0.5rem;
    }
  }
  
  @media (max-width: 768px) {
    .uaf-page-grid {
      grid-template-columns: 28% 1fr;
      grid-template-areas: "left middle";
    }
  
    .uaf-right-sidebar {
      display: none;
    }
  
    .uaf-left-sidebar {
      width: 100%;
    }
  
    .uac-main-feed {
      gap: 1rem;
    }
  
    .uaf-central-container {
      grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
      gap: 1rem;
      padding: 1rem;
    }
  
    .uaf-profile-container {
      flex-direction: column;
    }
  
    .uaf-top-container,
    .uaf-bottom-container {
      flex-direction: column;
      max-height: none;
    }
  
    .uaf-header-title {
      flex: 0 0 100%;
      max-width: 100%;
    }
  
    .uaf-search-bar {
      max-width: 100%;
    }
  }
  
  /* ==================== RESPONSIVE: MOBILE (< 768px) ==================== */
  
  @media (max-width: 640px) {
    .uaf-page-grid {
      grid-template-columns: 1fr;
      grid-template-areas: "middle";
      padding: 0.75rem;
    }
  
    .uaf-left-sidebar,
    .uaf-right-sidebar {
      display: none;
    }
  
    .uaf-middle-container {
      padding: 0 0 4rem 0;
    }
  
    .uaf-center-only-grid {
      padding: 0.75rem;
    }
  
    .uac-main-feed {
      gap: 1rem;
    }
  
    .uaf-central-container {
      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
      gap: 1rem;
      padding: 1rem;
    }
  
    .uaf-profile-card {
      width: 100%;
      height: auto;
      min-height: 180px;
    }
  
    .uaf-footer {
      padding: 1.5rem 0.75rem;
    }
  
    .uaf-footer-text {
      font-size: 0.75rem;
    }
  
    .uaf-top-container,
    .uaf-bottom-container {
      padding: 0.75rem;
    }
  
    .uaf-menu-option-dropdown {
      width: 160px;
      max-height: 250px;
    }
  }
  
  /* ==================== RESPONSIVE: EXTRA SMALL (< 480px) ==================== */
  
  @media (max-width: 480px) {
    .uaf-page-wrapper {
      padding: 0;
    }
  
    .uaf-page-grid,
    .uaf-center-only-grid {
      padding: 0.5rem;
    }
  
    .uac-main-feed {
      gap: 0.75rem;
      padding-bottom: 3rem;
    }
  
    .uaf-central-container {
      grid-template-columns: 1fr;
      gap: 0.75rem;
      padding: 0.75rem;
    }
  
    .uaf-footer {
      padding: 1.25rem 0.5rem;
    }
  
    .uaf-footer-text {
      font-size: 0.7rem;
      line-height: 1.4;
    }
  }
  
  /* ==================== PRINT STYLES ==================== */
  
  @media print {
    .uaf-left-sidebar,
    .uaf-right-sidebar,
    .uaf-footer {
      display: none;
    }
  
    .uaf-page-grid {
      grid-template-columns: 1fr;
      grid-template-areas: "middle";
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Pages/AccountPage/UserAccountGridLayout.css"],"names":[],"mappings":"AAAA,2DAA2D;;AAE3D;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;EACxB;;EAEA;;IAEE;yCACqC;IACrC,WAAW;IACX,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA,2DAA2D;EAC3D;IACE,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;;;;;;gEAM8D;;KAE3D;MACC,WAAW;MACX,aAAa;MACb,aAAa;;MAEb,aAAa;MACb,sBAAsB;MACtB,gBAAgB;MAChB,wBAAwB;IAC1B;;;IAGA;;;kEAG8D;;IAE9D;MACE,aAAa;;MAEb;;;aAGO;;MAEP;2BACqB;;MAErB,WAAW;;MAEX;;;QAGE;MACF,cAAc;MACd,aAAa;;MAEb;;;QAGE;MACF,YAAY;;MAEZ,wBAAwB;;MAExB;;QAEE;MACF,gBAAgB;MAChB,kBAAkB;;MAElB,uBAAuB;;MAEvB;;QAEE;MACF,qBAAqB;MACrB,wBAAwB;;MAExB,sBAAsB;IACxB;;;IAGA,2BAA2B;;IAE3B;MACE,QAAQ;MACR,SAAS;IACX;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,uBAAuB;IACzB;;AAEJ;;;8DAG8D;;AAE9D;EACE,iBAAiB;;EAEjB,UAAU;EACV,YAAY;EACZ,aAAa;;EAEb,aAAa;EACb,sBAAsB;EACtB,WAAW;;EAEX,yBAAyB;;EAEzB,sBAAsB;;EAEtB;;;IAGE;EACF,iBAAiB;;EAEjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,SAAS;AACX;;;AAGA;;;8DAG8D;;AAE9D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;EAEnB,WAAW;;EAEX,iBAAiB;;EAEjB,mBAAmB;;EAEnB;;IAEE;EACF,YAAY;EACZ,aAAa;EACb,gBAAgB;;EAEhB;;;IAGE;EACF,iBAAiB;;EAEjB,sBAAsB;AACxB;;EAEE,2DAA2D;;EAE3D;IACE,eAAe;IACf,gBAAgB;IAChB,MAAM;IACN,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,mCAAmC;IACnC,qBAAqB;IACrB,wBAAwB;IACxB,uBAAuB;IACvB,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA,+DAA+D;;;;EAI/D,4DAA4D;;EAE5D;IACE,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;IACN,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,2BAA2B;IAC3B,mCAAmC;IACnC,qBAAqB;IACrB,wBAAwB;IACxB,uBAAuB;IACvB,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,sBAAsB;EACxB;;EAEA,oEAAoE;;AAEtE;;;;;;EAME;CACD;EACC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;;EAGE;AACF;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;;;;+EAK+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,SAAS;AACX;;;EAGE;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,SAAS;EACX;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,yBAAiB;YAAjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,gCAAgC;IAChC,qBAAqB;IACrB,wBAAwB;IACxB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,SAAO;EACT;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,+BAA+B;IAC/B,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,oCAAoC;IACpC,YAAY;IACZ,0BAA0B;IAC1B,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,oCAAoC;IACpC,2BAA2B;EAC7B;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA,iEAAiE;;EAEjE;IACE,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,SAAO;EACT;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,oBAAoB;EACtB;;EAEA,2DAA2D;;EAE3D;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,oBAAoB,EAAE,6BAA6B;EACrD;;EAEA,gEAAgE;;EAEhE;IACE,WAAW;IACX,qFAAqF;IACrF,8CAA8C;IAC9C,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,SAAS;IACT,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,gBAAgB;EAClB;;EAEA,2EAA2E;;EAE3E;IACE,aAAa;IACb,4DAA4D;IAC5D,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,+BAA+B;IAC/B,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,cAAc;IACd,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;EAEA,kFAAkF;;EAElF;IACE;MACE,kCAAkC;MAClC,SAAS;MACT,aAAa;IACf;;IAEA;MACE,6BAA6B;IAC/B;EACF;;EAEA;IACE;MACE,8BAA8B;MAC9B,kCAAkC;IACpC;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,SAAS;IACX;;IAEA;MACE,4DAA4D;MAC5D,SAAS;MACT,aAAa;IACf;;IAEA;MACE,sBAAsB;IACxB;;IAEA;;MAEE,sBAAsB;MACtB,gBAAgB;IAClB;;IAEA;MACE,cAAc;MACd,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA,2EAA2E;;EAE3E;IACE;MACE,0BAA0B;MAC1B,6BAA6B;MAC7B,gBAAgB;IAClB;;IAEA;;MAEE,aAAa;IACf;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,SAAS;IACX;;IAEA;MACE,4DAA4D;MAC5D,SAAS;MACT,aAAa;IACf;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,iBAAiB;IACnB;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;;MAEE,gBAAgB;IAClB;;IAEA;MACE,YAAY;MACZ,iBAAiB;IACnB;EACF;;EAEA,gFAAgF;;EAEhF;IACE;MACE,UAAU;IACZ;;IAEA;;MAEE,eAAe;IACjB;;IAEA;MACE,YAAY;MACZ,oBAAoB;IACtB;;IAEA;MACE,0BAA0B;MAC1B,YAAY;MACZ,gBAAgB;IAClB;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,iBAAiB;MACjB,gBAAgB;IAClB;EACF;;EAEA,2DAA2D;;EAE3D;IACE;;;MAGE,aAAa;IACf;;IAEA;MACE,0BAA0B;MAC1B,6BAA6B;IAC/B;EACF","sourcesContent":["/* ==================== GLOBAL RESET ==================== */\n\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n  }\n  \n  body,\n  html {\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n      \"Helvetica Neue\", Arial, sans-serif;\n    width: 100%;\n    min-height: 100vh;\n    background-color: #100e0e;\n  }\n  \n  /* ==================== PAGE WRAPPER ==================== */\n  .uaf-page-wrapper {\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n    width: 100%;\n    background: #030303;\n    overflow: hidden;\n    box-sizing: border-box;\n  }\n  \n  /* =========================================================\n     MAIN PAGE\n     Fixed viewport.\n  \n     IMPORTANT:\n     The page itself DOES NOT scroll.\n     ========================================================= */\n  \n     .uaf-page {\n      width: 100%;\n      height: 100vh;\n      min-height: 0;\n    \n      display: flex;\n      flex-direction: column;\n      overflow: hidden;\n      background: rgb(4, 4, 4);\n    }\n    \n    \n    /* =========================================================\n       PAGE GRID\n       This is the ONLY scrolling region.\n       ========================================================= */\n    \n    .uaf-page-grid {\n      display: grid;\n    \n      grid-template-columns:\n        280px\n        minmax(0, 1fr)\n        280px;\n    \n      grid-template-areas:\n        \"left middle right\";\n    \n      width: 100%;\n    \n      /*\n       * Critical:\n       * grid must be allowed to shrink inside the viewport.\n       */\n      flex: 1 1 auto;\n      min-height: 0;\n    \n      /*\n       * Don't use height: 100vh here.\n       * The navbar + footer already consume part of the viewport.\n       */\n      height: auto;\n    \n      background: rgb(4, 4, 4);\n    \n      /*\n       * THIS is the only vertical scroll.\n       */\n      overflow-y: auto;\n      overflow-x: hidden;\n    \n      scroll-behavior: smooth;\n    \n      /*\n       * Hide scrollbar but preserve scrolling.\n       */\n      scrollbar-width: none;\n      -ms-overflow-style: none;\n    \n      box-sizing: border-box;\n    }\n    \n    \n    /* Chrome / Safari / Edge */\n    \n    .uaf-page-grid::-webkit-scrollbar {\n      width: 0;\n      height: 0;\n    }\n    \n    .uaf-page-grid::-webkit-scrollbar-track {\n      background: transparent;\n    }\n    \n    .uaf-page-grid::-webkit-scrollbar-thumb {\n      background: transparent;\n    }\n\n/* =========================================================\n   MIDDLE COLUMN\n   No independent scrolling\n   ========================================================= */\n\n.uaf-middle-container {\n  grid-area: middle;\n\n  width: 95%;\n  height: auto;\n  min-height: 0;\n\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n\n  padding: 0 1rem 4rem 1rem;\n\n  box-sizing: border-box;\n\n  /*\n   * IMPORTANT:\n   * Do NOT create another scroll container here.\n   */\n  overflow: visible;\n\n  scrollbar-width: none;\n}\n\n.uaf-middle-container::-webkit-scrollbar {\n  display: none;\n  width: 0;\n  height: 0;\n}\n\n\n/* =========================================================\n   FEED\n   Expands based on number of posts\n   ========================================================= */\n\n.uac-main-feed-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  width: 100%;\n\n  margin: 40px auto;\n\n  border-radius: 20px;\n\n  /*\n   * Let the feed grow naturally.\n   */\n  height: auto;\n  min-height: 0;\n  max-height: none;\n\n  /*\n   * IMPORTANT:\n   * No nested scrolling.\n   */\n  overflow: visible;\n\n  box-sizing: border-box;\n}\n\n  /* ==================== LEFT SIDEBAR ==================== */\n  \n  .uaf-left-sidebar {\n    grid-area: left;\n    position: sticky;\n    top: 0;\n    align-self: stretch;\n    height: 100vh;\n    max-height: 100vh;\n    overflow-y: auto;\n    overflow-x: hidden;\n    backdrop-filter: blur(10px);\n    -webkit-backdrop-filter: blur(10px);\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n    background: transparent;\n    padding: 0;\n    box-sizing: border-box;\n  }\n  \n  .uaf-left-sidebar::-webkit-scrollbar {\n    display: none;\n  }\n  \n  /* ==================== MIDDLE CONTAINER ==================== */\n  \n  \n  \n  /* ==================== RIGHT SIDEBAR ==================== */\n  \n  .uaf-right-sidebar {\n    grid-area: right;\n    position: sticky;\n    top: 0;\n    align-self: stretch;\n    height: 100vh;\n    max-height: 100vh;\n    backdrop-filter: blur(10px);\n    -webkit-backdrop-filter: blur(10px);\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n    background: transparent;\n    padding: 0;\n    box-sizing: border-box;\n  }\n  \n  .uaf-right-sidebar::-webkit-scrollbar {\n    display: none;\n  }\n  \n  .uaf-sidebar-inner {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    gap: 1.5rem;\n    justify-content: flex-start;\n    align-items: center;\n    padding: 1rem 0;\n    box-sizing: border-box;\n  }\n  \n  /* ==================== RIGHT SIDEBAR CONTENT ==================== */\n  \n/**\n * .uaf-ad-slot\n * 300x300 square placeholder. Both width/height AND aspect-ratio are set as a\n * belt-and-suspenders approach for older browser compatibility.\n * The dashed border and low-opacity background signal \"ad goes here\" to\n * developers without being visually distracting in the live UI.\n */\n .uaf-ad-slot {\n  width: 250px;\n  height: 250px;\n  aspect-ratio: 1 / 1;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.03);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgba(255, 255, 255, 0.4);\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  font-weight: 500;\n  transition: background 200ms ease;\n  flex-shrink: 0;\n  box-sizing: border-box;\n}\n\n.uaf-ad-slot:hover {\n  background: rgba(255, 255, 255, 0.06);\n}\n\n/**\n * .uaf-ad-placeholder-label\n * Non-interactive label inside each placeholder slot.\n */\n.uaf-ad-placeholder-label {\n  user-select: none;\n  pointer-events: none;\n}\n\n/* --------------------------------------------------------------------------\n   RIGHT SIDEBAR CONTENT CLASSES\n   Preserved verbatim from the original stylesheet — these power the real\n   profile-header / avatar / stars content that may be placed in the right\n   sidebar by other components.\n   -------------------------------------------------------------------------- */\n\n.uaf-right-content {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n}\n\n.uaf-right-top-section {\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n  gap: 1rem;\n}\n\n.uaf-right-profile-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem 0;\n}\n\n.uaf-right-profile-info {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.25rem;\n  width: 100%;\n}\n\n.uaf-right-profile-avatar {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid rgba(255, 255, 255, 0.15);\n  flex-shrink: 0;\n}\n\n.uaf-right-profile-details {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.uaf-right-profile-name {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.9);\n  margin: 0;\n}\n\n.uaf-right-profile-stars {\n  font-size: 0.75rem;\n  color: rgba(255, 255, 255, 0.5);\n  margin: 0;\n}\n\n\n  .uaf-right-content {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n    gap: 1rem;\n  }\n  \n  .uaf-right-top-section {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .uaf-right-profile-header {\n    padding: 0.75rem;\n    border-radius: 10px;\n  }\n  \n  .uaf-right-profile-info {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n  }\n  \n  .uaf-right-profile-avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    object-fit: cover;\n  }\n  \n  .uaf-right-profile-details {\n    flex: 1;\n  }\n  \n  .uaf-right-profile-name {\n    color: white;\n    font-weight: 600;\n    font-size: 1rem;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n  }\n  \n  .uaf-right-profile-stars {\n    color: #ffd700;\n    font-size: 0.875rem;\n  }\n  \n  .uaf-right-suggestions {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    padding: 0.75rem;\n    border-radius: 10px;\n  }\n  \n  .uaf-right-suggestions-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n    padding: 0.5rem 0;\n  }\n  \n  .uaf-right-suggestions-title {\n    color: white;\n    font-size: 1.125rem;\n    font-weight: 500;\n  }\n  \n  .uaf-right-toggle-icon {\n    font-size: 1.5rem;\n    color: white;\n    user-select: none;\n  }\n  \n  .uaf-right-suggestions-content {\n    overflow: hidden;\n    transition: max-height 0.3s ease;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n    min-height: 300px;\n  }\n  \n  .uaf-right-suggestions-content::-webkit-scrollbar {\n    display: none;\n  }\n  \n  .uaf-right-suggestions-content.collapsed {\n    max-height: 0;\n  }\n  \n  .uaf-right-suggestions-content.expanded {\n    max-height: 300px;\n    overflow-y: auto;\n    margin-top: 0.5rem;\n  }\n  \n  .uaf-right-suggestions-list {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n  \n  .uaf-right-suggestion-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.5rem;\n    border-radius: 8px;\n    transition: background 0.2s ease;\n  }\n  \n  .uaf-right-suggestion-item:hover {\n    background: rgba(255, 255, 255, 0.05);\n  }\n  \n  .uaf-right-suggestion-info {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    flex: 1;\n  }\n  \n  .uaf-right-suggestion-avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    object-fit: cover;\n  }\n  \n  .uaf-right-suggestion-details {\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n  }\n  \n  .uaf-right-suggestion-name {\n    color: white;\n    font-weight: 600;\n    font-size: 0.9rem;\n  }\n  \n  .uaf-right-suggestion-location {\n    color: rgba(200, 200, 200, 0.7);\n    font-size: 0.8rem;\n  }\n  \n  .uaf-right-connect-btn {\n    padding: 0.4rem 0.75rem;\n    border-radius: 6px;\n    cursor: pointer;\n    border: none;\n    font-size: 0.8rem;\n    background: rgba(255, 255, 255, 0.3);\n    color: white;\n    backdrop-filter: blur(6px);\n    transition: all 0.2s ease;\n    font-weight: 500;\n  }\n  \n  .uaf-right-connect-btn:hover {\n    background: rgba(255, 255, 255, 0.4);\n    transform: translateY(-1px);\n  }\n  \n  .uaf-right-connect-btn.connected {\n    background: rgba(234, 67, 53, 0.3);\n  }\n  \n  .uaf-right-bottom-section {\n    height: 200px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .uaf-right-ad-image {\n    width: 100%;\n    max-width: 200px;\n    height: 200px;\n    border-radius: 12px;\n    object-fit: cover;\n  }\n  \n  /* ==================== CENTER ONLY LAYOUT ==================== */\n  \n  .uaf-center-only-grid {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    max-width: 800px;\n    margin: 0 auto;\n    padding: 1.5rem;\n    flex: 1;\n  }\n  \n  .uaf-center-content {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    padding-bottom: 4rem;\n  }\n  \n  /* ==================== FEED WRAPPER ==================== */\n  \n  .uac-feed-wrapper {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n  }\n  \n  .uac-main-feed {\n    width: 100%;\n    max-width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    padding-bottom: 3rem; /* ✅ Extra space for footer */\n  }\n  \n  /* ==================== FOOTER (CENTERED) ==================== */\n  \n  .uaf-footer {\n    width: 100%;\n    background: linear-gradient(180deg, rgba(18, 18, 18, 0.95) 0%, rgba(0, 0, 0, 1) 100%);\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n    flex-shrink: 0;\n    display: flex;\n    justify-content: center;\n    height: 30px;\n  }\n  \n  .uaf-footer-content {\n    max-width: 1800px;\n    width: 100%;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  \n  .uaf-footer-text {\n    margin: 0;\n    color: rgba(255, 255, 255, 0.65);\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 1.4;\n  }\n  \n  .uaf-footer-copyright {\n    color: rgba(255, 255, 255, 0.7);\n    font-size: 0.875rem;\n    font-weight: 400;\n    margin: 0;\n    line-height: 1.4;\n  }\n  \n  /* ==================== PROFILE & CONTAINER VARIANTS ==================== */\n  \n  .uaf-central-container {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n    gap: 1.25rem;\n    padding: 1.25rem;\n    width: 100%;\n    max-width: 1200px;\n    margin: 0 auto;\n    min-height: 400px;\n  }\n  \n  .uaf-profile-container {\n    display: flex;\n    flex-direction: row;\n    gap: 1rem;\n    width: 100%;\n    max-width: 100%;\n    border-radius: 12px;\n    overflow: hidden;\n  }\n  \n  .uaf-profile-card {\n    width: 200px;\n    height: 200px;\n    border-radius: 12px;\n    overflow: hidden;\n    text-align: center;\n    transition: transform 0.3s ease;\n    background: rgb(34, 31, 31);\n  }\n  \n  .uaf-profile-card:hover {\n    transform: scale(1.05);\n  }\n  \n  .uaf-top-container {\n    width: 100%;\n    min-height: 100px;\n    border-radius: 12px;\n    display: flex;\n    flex-direction: row;\n    gap: 1rem;\n    padding: 1rem;\n    overflow: hidden;\n  }\n  \n  .uaf-bottom-container {\n    display: flex;\n    flex-direction: row;\n    gap: 1rem;\n    width: 100%;\n    max-height: 600px;\n    border-radius: 12px;\n    padding: 1rem;\n    overflow: hidden;\n  }\n  \n  .uaf-header-title {\n    flex: 0 0 40%;\n    max-width: 40%;\n    height: auto;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    border-radius: 12px;\n    overflow: hidden;\n  }\n  \n  .uaf-search-bar {\n    flex: 1;\n    max-width: 60%;\n    border-radius: 12px;\n    overflow: hidden;\n  }\n  \n  .uaf-option-navigation-container {\n    position: relative;\n    width: 100px;\n    height: auto;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n  }\n  \n  .uaf-menu-option-dropdown {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    width: 180px;\n    max-height: 300px;\n    background: rgb(34, 31, 31);\n    border-radius: 8px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);\n    z-index: 1000;\n    margin-top: 0.5rem;\n    overflow-y: auto;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n  \n  .uaf-menu-option-dropdown::-webkit-scrollbar {\n    display: none;\n  }\n  \n  .uaf-profile {\n    width: 100%;\n    height: auto;\n    padding: 1rem;\n  }\n  \n  /* ==================== RESPONSIVE: TABLET (768px - 1024px) ==================== */\n  \n  @media (max-width: 1024px) {\n    .uaf-page-grid {\n      grid-template-columns: 22% 1fr 25%;\n      gap: 1rem;\n      padding: 1rem;\n    }\n  \n    .uaf-middle-container {\n      padding: 0 0.5rem 4rem 0.5rem;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .uaf-page-grid {\n      grid-template-columns: 28% 1fr;\n      grid-template-areas: \"left middle\";\n    }\n  \n    .uaf-right-sidebar {\n      display: none;\n    }\n  \n    .uaf-left-sidebar {\n      width: 100%;\n    }\n  \n    .uac-main-feed {\n      gap: 1rem;\n    }\n  \n    .uaf-central-container {\n      grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n      gap: 1rem;\n      padding: 1rem;\n    }\n  \n    .uaf-profile-container {\n      flex-direction: column;\n    }\n  \n    .uaf-top-container,\n    .uaf-bottom-container {\n      flex-direction: column;\n      max-height: none;\n    }\n  \n    .uaf-header-title {\n      flex: 0 0 100%;\n      max-width: 100%;\n    }\n  \n    .uaf-search-bar {\n      max-width: 100%;\n    }\n  }\n  \n  /* ==================== RESPONSIVE: MOBILE (< 768px) ==================== */\n  \n  @media (max-width: 640px) {\n    .uaf-page-grid {\n      grid-template-columns: 1fr;\n      grid-template-areas: \"middle\";\n      padding: 0.75rem;\n    }\n  \n    .uaf-left-sidebar,\n    .uaf-right-sidebar {\n      display: none;\n    }\n  \n    .uaf-middle-container {\n      padding: 0 0 4rem 0;\n    }\n  \n    .uaf-center-only-grid {\n      padding: 0.75rem;\n    }\n  \n    .uac-main-feed {\n      gap: 1rem;\n    }\n  \n    .uaf-central-container {\n      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n      gap: 1rem;\n      padding: 1rem;\n    }\n  \n    .uaf-profile-card {\n      width: 100%;\n      height: auto;\n      min-height: 180px;\n    }\n  \n    .uaf-footer {\n      padding: 1.5rem 0.75rem;\n    }\n  \n    .uaf-footer-text {\n      font-size: 0.75rem;\n    }\n  \n    .uaf-top-container,\n    .uaf-bottom-container {\n      padding: 0.75rem;\n    }\n  \n    .uaf-menu-option-dropdown {\n      width: 160px;\n      max-height: 250px;\n    }\n  }\n  \n  /* ==================== RESPONSIVE: EXTRA SMALL (< 480px) ==================== */\n  \n  @media (max-width: 480px) {\n    .uaf-page-wrapper {\n      padding: 0;\n    }\n  \n    .uaf-page-grid,\n    .uaf-center-only-grid {\n      padding: 0.5rem;\n    }\n  \n    .uac-main-feed {\n      gap: 0.75rem;\n      padding-bottom: 3rem;\n    }\n  \n    .uaf-central-container {\n      grid-template-columns: 1fr;\n      gap: 0.75rem;\n      padding: 0.75rem;\n    }\n  \n    .uaf-footer {\n      padding: 1.25rem 0.5rem;\n    }\n  \n    .uaf-footer-text {\n      font-size: 0.7rem;\n      line-height: 1.4;\n    }\n  }\n  \n  /* ==================== PRINT STYLES ==================== */\n  \n  @media print {\n    .uaf-left-sidebar,\n    .uaf-right-sidebar,\n    .uaf-footer {\n      display: none;\n    }\n  \n    .uaf-page-grid {\n      grid-template-columns: 1fr;\n      grid-template-areas: \"middle\";\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
